// Kurye Yönetimi sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'couriers.management';

export const courierManagementGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Kurye Yönetimi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Kuryelerinizi buradan eklersiniz, durumlarını ve konumlarını izlersiniz, hangi şubelerden hangi siparişleri alacaklarını belirlersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    toolbar: t(`${G}.regions.toolbar`, 'Yeni Kurye Ekle, Kurye Takip'),
    stats: t(`${G}.regions.stats`, 'Özet kartları'),
    table: t(`${G}.regions.table`, 'Kurye Listesi ve ⋮ menüsü'),
  },
  steps: [
    {
      region: 'stats',
      title: t(`${G}.s1.title`, '1. Özet kartlarını okuyun'),
      text: t(`${G}.s1.text`, 'Toplam Kurye kayıtlı kurye sayısını, Aktif Kurye durumu "Aktif" olanları, Bugünkü Teslimat kuryelerin bugün tamamladığı teslimatların toplamını, Ortalama Puan da kuryelerin puan ortalamasını gösterir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Henüz puanı olmayan kurye ortalamaya 5,0 olarak katılır.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s2.title`, '2. Kurye ekleyin'),
      text: t(`${G}.s2.text`, '"Yeni Kurye Ekle" personel listesini açar. Kurye yapmak istediğiniz personeli seçin, "Yetkileri Düzenle" ile kurye uygulamasında neleri yapabileceğini (sipariş görme, durum güncelleme, müşteriyi arama vb.) belirleyip kaydedin. Kurye bu listeye eklenir.'),
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Listeyi ve durumları okuyun'),
      text: t(`${G}.s3.text`, 'Her satırda kuryenin iletişim bilgisi, Durum (Aktif, Meşgul, Çevrimdışı), Bugün ve Toplam teslimat sayısı, Puan ve çalıştığı Şube görünür. Şubesi seçilmemiş kuryede "Şube Atanmamış" yazar.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Kuryenin konumuna bakın'),
      text: t(`${G}.s4.text`, 'Konum sütunu kuryenin son bildirdiği konumu gösterir. Konum simgesi yeşilse tıklayın: harita penceresi açılır, son güncelleme zamanı ve koordinatlar görünür; "Google Maps\'te Aç" ile konumu Google Haritalar\'da açabilirsiniz.'),
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Sipariş ayarları'),
      text: t(`${G}.s5.text`, 'Satırdaki ⋮ menüsünden "Sipariş Ayarları"nı açın. "Çalışacağı Şubeler" bölümünde kuryenin sipariş alacağı şubeleri (birden fazla olabilir), "Sipariş Türü Ayarları" bölümünde teslim edebileceği sipariş türlerini seçip kaydedin.'),
    },
    {
      region: 'table',
      title: t(`${G}.s6.title`, '6. Kurye yetkilerini kaldırın'),
      text: t(`${G}.s6.text`, '⋮ menüsündeki "Kurye Yetkilerini Kaldır" onay sorar. Onaylarsanız kişi kurye uygulamasına giriş yapamaz, kurye yetkileri kaldırılır, kişi normal personel rolüne döner. Personel kaydı silinmez; kurye geçmişi korunur.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s7.title`, '7. Teslimatları takip edin'),
      text: t(`${G}.s7.text`, '"Kurye Takip" düğmesi kuryelerin aldığı ve teslim ettiği siparişleri listeleyen Kurye Takip ekranını açar. Oradan geri okuyla bu sayfaya dönersiniz.'),
    },
  ],
});
